export const DEFAULT_COUNTRY_CODES = [
    { name: 'India', code: 'IN', dialCode: '+91' },
    { name: 'Afghanistan', code: 'AF', dialCode: '+93' },
    { name: 'Albania', code: 'AL', dialCode: '+355' },
    { name: 'Algeria', code: 'DZ', dialCode: '+213' },
    { name: 'Andorra', code: 'AD', dialCode: '+376' },
    { name: 'Angola', code: 'AO', dialCode: '+244' },
    { name: 'Argentina', code: 'AR', dialCode: '+54' },
    { name: 'Armenia', code: 'AM', dialCode: '+374' },
    { name: 'Australia', code: 'AU', dialCode: '+61' },
    { name: 'Austria', code: 'AT', dialCode: '+43' },
    { name: 'Azerbaijan', code: 'AZ', dialCode: '+994' },
    { name: 'Bahrain', code: 'BH', dialCode: '+973' },
    { name: 'Bangladesh', code: 'BD', dialCode: '+880' },
    { name: 'Belarus', code: 'BY', dialCode: '+375' },
    { name: 'Belgium', code: 'BE', dialCode: '+32' },
    { name: 'Bhutan', code: 'BT', dialCode: '+975' },
    { name: 'Bolivia', code: 'BO', dialCode: '+591' },
    { name: 'Bosnia and Herzegovina', code: 'BA', dialCode: '+387' },
    { name: 'Botswana', code: 'BW', dialCode: '+267' },
    { name: 'Brazil', code: 'BR', dialCode: '+55' },
    { name: 'Brunei', code: 'BN', dialCode: '+673' },
    { name: 'Bulgaria', code: 'BG', dialCode: '+359' },
    { name: 'Cambodia', code: 'KH', dialCode: '+855' },
    { name: 'Cameroon', code: 'CM', dialCode: '+237' },
    { name: 'Canada', code: 'CA', dialCode: '+1' },
    { name: 'Chile', code: 'CL', dialCode: '+56' },
    { name: 'China', code: 'CN', dialCode: '+86' },
    { name: 'Colombia', code: 'CO', dialCode: '+57' },
    { name: 'Costa Rica', code: 'CR', dialCode: '+506' },
    { name: 'Croatia', code: 'HR', dialCode: '+385' },
    { name: 'Cuba', code: 'CU', dialCode: '+53' },
    { name: 'Cyprus', code: 'CY', dialCode: '+357' },
    { name: 'Czech Republic', code: 'CZ', dialCode: '+420' },
    { name: 'Denmark', code: 'DK', dialCode: '+45' },
    { name: 'Dominican Republic', code: 'DO', dialCode: '+1' },
    { name: 'Ecuador', code: 'EC', dialCode: '+593' },
    { name: 'Egypt', code: 'EG', dialCode: '+20' },
    { name: 'El Salvador', code: 'SV', dialCode: '+503' },
    { name: 'Estonia', code: 'EE', dialCode: '+372' },
    { name: 'Ethiopia', code: 'ET', dialCode: '+251' },
    { name: 'Finland', code: 'FI', dialCode: '+358' },
    { name: 'France', code: 'FR', dialCode: '+33' },
    { name: 'Georgia', code: 'GE', dialCode: '+995' },
    { name: 'Germany', code: 'DE', dialCode: '+49' },
    { name: 'Ghana', code: 'GH', dialCode: '+233' },
    { name: 'Greece', code: 'GR', dialCode: '+30' },
    { name: 'Guatemala', code: 'GT', dialCode: '+502' },
    { name: 'Honduras', code: 'HN', dialCode: '+504' },
    { name: 'Hong Kong', code: 'HK', dialCode: '+852' },
    { name: 'Hungary', code: 'HU', dialCode: '+36' },
    { name: 'Iceland', code: 'IS', dialCode: '+354' },
    { name: 'Indonesia', code: 'ID', dialCode: '+62' },
    { name: 'Iran', code: 'IR', dialCode: '+98' },
    { name: 'Iraq', code: 'IQ', dialCode: '+964' },
    { name: 'Ireland', code: 'IE', dialCode: '+353' },
    { name: 'Israel', code: 'IL', dialCode: '+972' },
    { name: 'Italy', code: 'IT', dialCode: '+39' },
    { name: 'Jamaica', code: 'JM', dialCode: '+1' },
    { name: 'Japan', code: 'JP', dialCode: '+81' },
    { name: 'Jordan', code: 'JO', dialCode: '+962' },
    { name: 'Kazakhstan', code: 'KZ', dialCode: '+7' },
    { name: 'Kenya', code: 'KE', dialCode: '+254' },
    { name: 'Kuwait', code: 'KW', dialCode: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', dialCode: '+996' },
    { name: 'Laos', code: 'LA', dialCode: '+856' },
    { name: 'Latvia', code: 'LV', dialCode: '+371' },
    { name: 'Lebanon', code: 'LB', dialCode: '+961' },
    { name: 'Libya', code: 'LY', dialCode: '+218' },
    { name: 'Lithuania', code: 'LT', dialCode: '+370' },
    { name: 'Luxembourg', code: 'LU', dialCode: '+352' },
    { name: 'Macau', code: 'MO', dialCode: '+853' },
    { name: 'Malaysia', code: 'MY', dialCode: '+60' },
    { name: 'Maldives', code: 'MV', dialCode: '+960' },
    { name: 'Mexico', code: 'MX', dialCode: '+52' },
    { name: 'Moldova', code: 'MD', dialCode: '+373' },
    { name: 'Mongolia', code: 'MN', dialCode: '+976' },
    { name: 'Morocco', code: 'MA', dialCode: '+212' },
    { name: 'Myanmar', code: 'MM', dialCode: '+95' },
    { name: 'Nepal', code: 'NP', dialCode: '+977' },
    { name: 'Netherlands', code: 'NL', dialCode: '+31' },
    { name: 'New Zealand', code: 'NZ', dialCode: '+64' },
    { name: 'Nigeria', code: 'NG', dialCode: '+234' },
    { name: 'North Korea', code: 'KP', dialCode: '+850' },
    { name: 'Norway', code: 'NO', dialCode: '+47' },
    { name: 'Oman', code: 'OM', dialCode: '+968' },
    { name: 'Pakistan', code: 'PK', dialCode: '+92' },
    { name: 'Panama', code: 'PA', dialCode: '+507' },
    { name: 'Paraguay', code: 'PY', dialCode: '+595' },
    { name: 'Peru', code: 'PE', dialCode: '+51' },
    { name: 'Philippines', code: 'PH', dialCode: '+63' },
    { name: 'Poland', code: 'PL', dialCode: '+48' },
    { name: 'Portugal', code: 'PT', dialCode: '+351' },
    { name: 'Qatar', code: 'QA', dialCode: '+974' },
    { name: 'Romania', code: 'RO', dialCode: '+40' },
    { name: 'Russia', code: 'RU', dialCode: '+7' },
    { name: 'Saudi Arabia', code: 'SA', dialCode: '+966' },
    { name: 'Serbia', code: 'RS', dialCode: '+381' },
    { name: 'Singapore', code: 'SG', dialCode: '+65' },
    { name: 'Slovakia', code: 'SK', dialCode: '+421' },
    { name: 'Slovenia', code: 'SI', dialCode: '+386' },
    { name: 'South Africa', code: 'ZA', dialCode: '+27' },
    { name: 'South Korea', code: 'KR', dialCode: '+82' },
    { name: 'Spain', code: 'ES', dialCode: '+34' },
    { name: 'Sri Lanka', code: 'LK', dialCode: '+94' },
    { name: 'Sweden', code: 'SE', dialCode: '+46' },
    { name: 'Switzerland', code: 'CH', dialCode: '+41' },
    { name: 'Syria', code: 'SY', dialCode: '+963' },
    { name: 'Taiwan', code: 'TW', dialCode: '+886' },
    { name: 'Thailand', code: 'TH', dialCode: '+66' },
    { name: 'Turkey', code: 'TR', dialCode: '+90' },
    { name: 'Ukraine', code: 'UA', dialCode: '+380' },
    { name: 'United Arab Emirates', code: 'AE', dialCode: '+971' },
    { name: 'United Kingdom', code: 'GB', dialCode: '+44' },
    { name: 'United States', code: 'US', dialCode: '+1' },
    { name: 'Uruguay', code: 'UY', dialCode: '+598' },
    { name: 'Uzbekistan', code: 'UZ', dialCode: '+998' },
    { name: 'Venezuela', code: 'VE', dialCode: '+58' },
    { name: 'Vietnam', code: 'VN', dialCode: '+84' },
    { name: 'Yemen', code: 'YE', dialCode: '+967' },
    { name: 'Zimbabwe', code: 'ZW', dialCode: '+263' }
];

export function getPhoneParts(
    phone: string,
    countryCodesList: Array<{
        name: string;
        code: string;
        dialCode: string;
    }> = DEFAULT_COUNTRY_CODES
) {
    const cleaned = (phone || '').replace(/\s/g, '');
    const match = [...countryCodesList]
        .sort((a, b) => b.dialCode.length - a.dialCode.length)
        .find((country) => cleaned.startsWith(country.dialCode));

    const defaultCountry = countryCodesList.find(c => c.code === 'IN') || countryCodesList[0] || {
        name: '',
        code: '',
        dialCode: '+'
    };

    return {
        country: match || defaultCountry,
        nationalNumber: match ? cleaned.slice(match.dialCode.length).replace(/\D/g, '') : cleaned.replace(/\D/g, ''),
    };
}

export function maskPhone(phone: string): string {
    return phone || '';
}
